import { getDateInFormat } from "@domains/utils/reportDates";
export const opRecommendationMapper = (data) => {
    const opRecommendationEntity = {
        stockOptions: [],
        indexOptions: [],
    };
    if (data) {
        if (data.idxoptlst && data.idxoptlst.length > 0) {
            data.idxoptlst.map((record) => {
                const recommendationObj = recObject(record);
                opRecommendationEntity.indexOptions.push(recommendationObj);
            });
        }
        if (data.stkoptlst && data.stkoptlst.length > 0) {
            data.stkoptlst.map((record) => {
                const recommendationObj = recObject(record);
                opRecommendationEntity.stockOptions.push(recommendationObj);
            });
        }
        return opRecommendationEntity;
    }
    else {
        return opRecommendationEntity;
    }
};
const recObject = (record) => {
    var _a, _b, _c, _d, _e, _f;
    const recommendationObj = {
        scripName: (_a = record.stkLst[0]) === null || _a === void 0 ? void 0 : _a.desc,
        lastTradedPrice: (_b = record.stkLst[0]) === null || _b === void 0 ? void 0 : _b.ltp,
        change: (_c = record.stkLst[0]) === null || _c === void 0 ? void 0 : _c.chg,
        changePercentage: (_d = record.stkLst[0]) === null || _d === void 0 ? void 0 : _d.chgP,
        recommendation: (_e = record.act) === null || _e === void 0 ? void 0 : _e.dpAct,
        recoDate: getDateInFormat(record.stDt, "DD-MMM-YY"),
        recoPrice: record.entryPrc,
        targetPrice: record.tgtPrc1,
        stopLoss: record.slPrc,
        type: record.rcTyp,
        currentReturns: record.rt,
        exitDate: getDateInFormat(record.upDt, "DD-MMM-YY"),
        exitPrice: record.exitPrc,
        symbol: (_f = record.stkLst[0]) === null || _f === void 0 ? void 0 : _f.sym,
        achievedReturns: "",
        marketCap: "",
    };
    return recommendationObj;
};
